import { combineReducers } from 'redux';
import { actionTypes } from '../../../controller';

import serviceSetting from './singles/service-setting';
import platformSetting from './singles/platform-setting';
import auth from './singles/auth';
import language from './singles/language';
import sound from './singles/sound';
import article from './singles/article';
import conversation from './singles/conversation';
import conversationReply from './singles/conversation-reply';
import application from './singles/application';
import translate from './singles/translate';
import conversationError from './singles/conversation-error';
import captcha from './singles/captcha';
import previewImage from './singles/preview-image';
import quotation from './singles/quotation';
import logger from './singles/logger';

const { START_LOGOUT } = actionTypes;
const reducer = combineReducers({
	serviceSetting,
	platformSetting,
	auth,
	language,
	sound,
	article,
	conversation,
	conversationReply,
	application,
	translate,
	conversationError,
	captcha,
	previewImage,
	quotation,
	logger,
});
const appReducer = (state, action) => {
	if (action.type === START_LOGOUT) {
		state = undefined;
	}

	return reducer(state, action);
};

export default appReducer;
